import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CreateManufacturerPayload } from "../../../products/types";
import api from "../../http";
import { getApiErrorMessage, toApiError } from "../utils";

export const usePostManufacturer = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (payload: CreateManufacturerPayload) => {
            try {
                return (await api.post('/manufacturer/create', payload)).data;
            } catch (error) {
                throw toApiError(error, 'Erro ao criar fabricante');
            }
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['manufacturers'] });
        },
        onError: (error) => {
            console.error('Erro ao criar fabricante:', getApiErrorMessage(error, 'Erro ao criar fabricante'))
        },
    });
};
